module.exports = __webpack_public_path__ + "img/oficina-estudio9-1.acf4cccb.jpg";